import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";

type ReviewerNameRow = {
  reviewer_name: string;
};

export const ReviewerNameCol = <
  T extends ReviewerNameRow = ReviewerNameRow,
>(): ColumnDef<T> => ({
  header: "Reviewer",
  accessorFn: (row) => (row.reviewer_name || "").trim().toLowerCase(),
  accessorKey: "reviewer_name",
  sortingFn: "alphanumeric",
  cell: ({ getValue }) => (
    <LineClampedTooltip>{getValue() as string}</LineClampedTooltip>
  ),
});
